/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

/**
 * Formats seconds into a time string like "m:ss" or "H:mm:ss".
 * E.g. 65 -> "1:05", 3661 -> "1:01:01"
 */
export function formatCurrentTime(totalSeconds: number): string {
  const absSeconds = Math.max(0, Math.floor(Math.abs(totalSeconds)));
  const sign = totalSeconds < 0 ? "-" : "";

  const hours = Math.floor(absSeconds / 3600);
  const minutes = Math.floor((absSeconds % 3600) / 60);
  const seconds = absSeconds % 60;

  const pad = (n: number) => n.toString().padStart(2, "0");

  if (hours > 0) {
    return `${sign}${hours}:${pad(minutes)}:${pad(seconds)}`;
  }

  return `${sign}${minutes}:${pad(seconds)}`;
}

/**
 * Formats milliseconds into a time string with given format.
 * Supported formats: "HH:mm", "HH:mm:ss", "(HH):mm:ss"
 * E.g. 3661000, "HH:mm:ss" -> "01:01:01"
 */
export function formatDurationMs(
  milliseconds: number,
  format: "HH:mm" | "HH:mm:ss" | "(HH):mm:ss" = "HH:mm",
): string {
  const totalSeconds = Math.floor(Math.abs(milliseconds) / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  const pad = (n: number) => n.toString().padStart(2, "0");

  switch (format) {
    case "HH:mm":
      return `${pad(hours)}:${pad(minutes)}`;
    case "HH:mm:ss":
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
    case "(HH):mm:ss":
      if (hours > 0) {
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
      }
      return `${pad(minutes)}:${pad(seconds)}`;
    default:
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  }
}
